// Import JS
import './_addon';

// Select2
import './_select';

// Mobile Menu
import './_mobile-menu';

// Sliders
import './_sliders';

// Parallax
import './_parallax';

// Scroll Reveal
import './_reveal';

// Scroll to Fixed
import './_fixed-elements';

// Util bootstrap
import './_util';

// Fancybox Options
import './_fancybox';

// Vue
import './_vue';